import classes from "./Errorpage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const ErrorPage = (props) => {
  return (
    <div style={{paddingTop: '15%'}}>
    <span className={classes.circlegif}>
      <FontAwesomeIcon icon={faExclamationTriangle}  />
    </span>
    <p className="text-center">{props.error.message}</p>
  </div>
  );
};

export default ErrorPage;
